import classnames from 'classnames';
import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import { isMobileState } from '../../recoil/selectors';
import { PlusMinusToggle } from '../../root/components/PlusMinusToggle';
import { v4 as uuid } from 'uuid';
import styles from './CollapsePanel.module.scss';

interface Props {
  title?: string | React.ReactNode;
  iconElement?: React.ReactNode;
  hideTitleOnOpen?: boolean;
  active: boolean;
  toggle: () => void;
  lastInList?: boolean;
  titleColor?: string;
  wrapperStyle?: React.CSSProperties;
  panelStyle?: React.CSSProperties;
  toggleStyle?: React.CSSProperties;
  useSmallIcon?: boolean;
  mobileOnly?: boolean;
  hideToggle?: boolean;
}

export const CollapsePanel: React.FC<Props> = ({
  title,
  active,
  toggle,
  children,
  titleColor = 'black',
  lastInList = false,
  wrapperStyle = {},
  panelStyle = {},
  toggleStyle = {},
  useSmallIcon,
  mobileOnly,
  hideTitleOnOpen,
  hideToggle,
  iconElement,
}) => {
  const isMobile = useRecoilValue(isMobileState);
  const [regionId] = useState<string>(uuid());

  return (
    <React.Fragment>
      {mobileOnly && !isMobile && (
        <div>
          {typeof title === 'string' ? (
            <span style={{ flex: '1', color: titleColor }} className={styles.collapsePanelTitle}>
              {title}
            </span>
          ) : (
            title
          )}
          {children}
        </div>
      )}
      {(!mobileOnly || isMobile) && (
        <div className={classnames(styles.collapsePanel, { [styles.active]: active })} style={panelStyle}>
          <div className={classnames(styles.panelWrapper, { [styles.last]: lastInList })} style={{ minHeight: 22, ...wrapperStyle }}>
            <button
              className={styles.panelToggle}
              style={toggleStyle}
              onClick={() => toggle()}
              onKeyUp={() => toggle()}
              aria-expanded={active}
              aria-controls={regionId}
            >
              {(hideTitleOnOpen && active) || !title ? (
                <span style={{ flex: 1 }} />
              ) : typeof title === 'string' ? (
                <span style={{ flex: '1', color: titleColor }} className={classnames(styles.collapsePanelTitle, styles.fadeInTitle)}>
                  {title}
                </span>
              ) : (
                title
              )}
              {!hideToggle && !iconElement && <PlusMinusToggle active={active} color={titleColor} useSmallIcon={useSmallIcon} />}
              {!hideToggle && iconElement}
            </button>
            <div id={regionId} className={styles.collapsePanelBody} style={{ marginTop: title && !hideTitleOnOpen ? 'unset' : '-20px' }}>
              {children}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default CollapsePanel;
